import { TranslateModule } from '@ngx-translate/core';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ExpiredBasketComponent } from './expired-basket.component';

@NgModule({
    imports: [RouterModule, CommonModule, FormsModule, TranslateModule],
    declarations: [ExpiredBasketComponent],
    exports: [ExpiredBasketComponent],
})
export class ExpiredBasketModule {}
